// The currencies a company's figures can be in — for a list row that names only a currency_id (a
// document in the Sales list, a draft on the dashboard, a search hit). Owner 2026-10-19: "I DO NOT WANT
// CURRENCIES TO BLEED INTO EACH OTHER" — every figure carries the mark of the currency it is in, so a
// row's currency_id must turn into that currency's symbol, never the company's.
// One light read per company per page load: GET …/settings/currencies (every reference currency + the
// company base). A failed read is forgotten, so the next figure that needs it asks again.
import { api } from './api.js';

const _cache = new Map();

/** → Promise<{ byId: Map(id → { id, code, symbol }), base: { id, code, symbol } | null }> */
export function companyCurrencies(companyId){
  const key = String(companyId);
  if(!_cache.has(key)){
    const p = api.get('/companies/' + companyId + '/settings/currencies').then(r => {
      const byId = new Map(((r && r.currencies) || []).filter(c => c && c.id !== null && c.id !== undefined)
        .map(c => [String(c.id), { id: c.id, code: c.code || '', symbol: c.symbol || '' }]));
      const co = (r && r.company) || {};
      const base = (co.base_currency_id !== null && co.base_currency_id !== undefined)
        ? { id: co.base_currency_id, code: co.code || '', symbol: co.symbol || '' } : null;
      if(base) byId.set(String(base.id), base);
      return { byId, base };
    }).catch(() => { _cache.delete(key); return { byId: new Map(), base: null }; });
    _cache.set(key, p);
  }
  return _cache.get(key);
}

/** Drop a company's cached list (its base currency or enabled set just changed). */
export function forgetCompanyCurrencies(companyId){ _cache.delete(String(companyId)); }

/** True when some row names its currency only by id — the list above is needed to mark it. */
export function needsCurrencyLookup(rows){
  return (rows || []).some(r => r && !r.currency_symbol && !r.currency_code
    && r.currency_id !== null && r.currency_id !== undefined && r.currency_id !== '');
}
